import { Mail, Phone, UserRound } from 'lucide-react';

interface Props {
  guestName: string;
  phone: string | null | undefined;
  email: string | null | undefined;
}

export function BookingContactSummary({ guestName, phone, email }: Props) {
  return (
    <div className="space-y-3">
      <p className="text-ink flex items-center gap-2 font-semibold">
        <UserRound size={17} className="text-postmark shrink-0" />
        <span className="min-w-0 break-words">{guestName}</span>
      </p>
      <Contact icon={Phone} href={phone ? `tel:${phone}` : null} value={phone} />
      <Contact icon={Mail} href={email ? `mailto:${email}` : null} value={email} />
    </div>
  );
}

function Contact({
  icon: Icon,
  href,
  value,
}: {
  icon: typeof Phone;
  href: string | null;
  value: string | null | undefined;
}) {
  const content = (
    <>
      <Icon size={16} className="text-postmark shrink-0" />
      <span className="min-w-0 break-all">{value?.trim() || 'nicht hinterlegt'}</span>
    </>
  );
  return href ? (
    <a
      className="text-postmark flex min-h-11 items-center gap-2 text-sm hover:underline"
      href={href}
    >
      {content}
    </a>
  ) : (
    <div className="text-ink-soft flex min-h-11 items-center gap-2 text-sm">{content}</div>
  );
}
